import React from "react";
import { Button } from "primereact/button";
import { StepCallBack } from "@modules/plaintes/plaintes.model.ts";
import AggressorForm from "./AggressorForm.tsx";
import { useAppDispatch, useAppSelector } from "@core/store/hook.ts";
import {
  agressorsInfos,
  setAgressorsInfos,
} from "@core/slice/ComplaintSlice.ts";

export interface AggressorError {
  lastName: string;
  firstName: string;
  sex: string;
  age: string | number;
  nationality: string;
  relation: string;
}

const AgressorInfos: React.FC<StepCallBack> = ({ onNext, onPrevious }) => {
  const dispatch = useAppDispatch();
  const aggressors = useAppSelector(agressorsInfos);

  const [errors, setErrors] = React.useState<AggressorError[]>([]);

  const handleAggressorChange = (index: number, field: string, value: any) => {
    dispatch(
      setAgressorsInfos(
        aggressors.map((aggressor, i) =>
          i === index
            ? {
                ...aggressor,
                [field]: field === "age" && value?.code ? value?.code : value,
              }
            : aggressor
        )
      )
    );
  };

  const addForm = () => {
    dispatch(
      setAgressorsInfos([
        ...aggressors,
        {
          id: aggressors.length,
          lastName: "",
          firstName: "",
          sex: "",
          age: undefined,
          nationality: "",
          relation: undefined,
          adresse: "",
        },
      ])
    );
  };

  // Supprimer un agresseur
  const removeForm = (index: number) => {
    dispatch(setAgressorsInfos(aggressors.filter((_, i) => i !== index)));
  };

  function handlePreviousStep() {
    if (onPrevious) {
      onPrevious();
    }
  }
  function handleNextStep() {
    let formErrors: AggressorError[] = [...errors];
    let isValid = true;

    aggressors.forEach((aggressor, index) => {
      formErrors[index] = {
        lastName: aggressor.lastName?.trim(),
        firstName: aggressor.firstName?.trim(),
        sex: aggressor.sex?.trim() ? "" : "Veuillez choisir le sexe",
        age: aggressor.age ? "" : "Veuillez choisir l'âge",
        nationality: aggressor.nationality?.trim()
          ? ""
          : "Veuillez remplir le champ nationalité",
        relation: aggressor.relation?.name
          ? ""
          : "Veuillez remplir le champ relation"
      };

      if (
        formErrors[index].sex ||
        formErrors[index].relation ||
        formErrors[index].nationality ||
        formErrors[index].age
      ) {
        isValid = false;
      }
    });

    setErrors(formErrors);

    if (isValid) {
      onNext();
    } else {
      console.log("Des erreurs ont été trouvées");
    }
  }

  const clearError = (index: number, field: string) => {
    setErrors((prevErrors) => {
      const newErrors = [...prevErrors];
      if (newErrors[index]) {
        newErrors[index] = { ...newErrors[index], [field]: "" };
      }
      return newErrors;
    });
  };
  
  return (
    <div className="column gap-[20px] card-stepper">
      <div className="stitle">Informations sur le présumé auteur</div>
      {aggressors.map((aggressor, index) => (
        <React.Fragment key={`info-${aggressor.id}`}>
          <AggressorForm
            index={index}
            isLast={index === aggressors.length - 1}
            addForm={addForm}
            removeForm={removeForm}
            formsLength={aggressors.length}
            handleChange={handleAggressorChange}
            aggressor={aggressor}
            error={errors[index] || {}}
            clearError={clearError}
          />
          {index < aggressors.length - 1 && (
            <hr className="my-4 border-t border-gray-500" />
          )}
        </React.Fragment>
      ))}
      <div className="flex gap-3 justify-content-end">
        <div className="flex justify-content-end">
          <Button
            label="Précédent"
            className="btn btn-secondary w-[120px]"
            onClick={handlePreviousStep}
          />
        </div>
        <div className="flex justify-content-end">
          <Button
            label="Suivant"
            className="btn btn-primary w-[120px]"
            onClick={handleNextStep}
          />
        </div>
      </div>
    </div>
  );
};

export default AgressorInfos;
